import { createReadingConditionStore } from '@/stores/conditionStore';
import Timer from '@/utils/timer';
import {ConditionsDTO} from "./conditionsDTO";
import {ConditionsReferentialBuilder} from "./conditionsReferentialBuilder";
import {ConditionsCalculator} from "./conditionsCalculator";
import _ from "lodash";
import objectHandler from "../objectHandler";

export class ConditionsController {
  constructor(configuration, context, readingId) {
    const unProxiedContext = objectHandler.recursiveDeepCopy(context)
    unProxiedContext.nowDatetime = context.nowDatetime
    const unProxiedConfiguration = objectHandler.recursiveDeepCopy(configuration)
    this.conditionsDTO = new ConditionsDTO(unProxiedConfiguration, unProxiedContext, readingId);
    this.conditionsReferentialBuilder = new ConditionsReferentialBuilder(this.conditionsDTO)
    this.conditionsCalculator = new ConditionsCalculator(this.conditionsDTO)
    this.readingConditionStore = createReadingConditionStore(this.conditionsDTO.readingId);
  }

  initScreenAndGroupConditions() {
    Object.values(this.conditionsDTO.associativeScreen)?.forEach(
      function (screen) {
        this.conditionsCalculator.handleScreenConditions(screen, { ...this.conditionsDTO.context })
      }.bind(this)
    )
    Object.values(this.conditionsDTO.associativeGroup)?.forEach(
      function (group) {
        this.conditionsCalculator.handleGroupConditions(group, { ...this.conditionsDTO.context })
      }.bind(this)
    )
  }

  createConditions() {
    const conditionsTimer = new Timer(this.conditionsDTO.focused?'updateConditions':'createConditions', 2)
    if (!this.conditionsDTO.focused) {
      this.readingConditionStore.initReading()
      conditionsTimer.echoStep('initReading')
    }
    let conditionsQuestions = objectHandler.recursiveDeepCopy(this.readingConditionStore?.questions)
    let conditionsScreens = objectHandler.recursiveDeepCopy(this.readingConditionStore?.screens)
    let conditionsGroups = objectHandler.recursiveDeepCopy(this.readingConditionStore?.groups)
    this.conditionsReferentialBuilder.buildAttachmentReferential()
    conditionsTimer.echoStep('buildAttachmentReferential')
    this.conditionsDTO.createScreenAttachments()
    conditionsTimer.echoStep('createScreenAttachments')
    this.initScreenAndGroupConditions()
    conditionsTimer.echoStep('initScreenAndGroupConditions')
    const questionsContext = { ...this.conditionsDTO.context }
    this.conditionsCalculator.createQuestionConditions(questionsContext)
    setTimeout(() => {
      this.readingConditionStore.massUpsert('questions', this.conditionsDTO.questionsToInsert)
    }, 0)
    _.merge(conditionsQuestions, objectHandler.mapToObject(this.conditionsDTO.questionsToInsert))
    conditionsTimer.echoStep('createQuestionConditions')
    this.conditionsDTO.removeInvisibleQuestionsFromVisibleQuestionsPerGroup(conditionsQuestions)
    this.conditionsDTO.removeInvisibleQuestionsFromVisibleQuestionsPerScreen(conditionsQuestions)
    conditionsTimer.echoStep('removeInvisibleQuestionsFromVisibleQuestionsPerGroupAndScreen')
    this.conditionsDTO.updateEmptyScreenVisibility()
    setTimeout(() => {
      this.readingConditionStore.massUpsert('screens', this.conditionsDTO.screensToInsert)
    },0)
    _.merge(conditionsScreens, objectHandler.mapToObject(this.conditionsDTO.screensToInsert))
    conditionsTimer.echoStep('updateEmptyScreenVisibility')
    this.conditionsDTO.updateEmptyGroupVisibility()
    setTimeout(() => {
      this.readingConditionStore.massUpsert('groups', this.conditionsDTO.groupsToInsert)
    },0)
    _.merge(conditionsGroups, objectHandler.mapToObject(this.conditionsDTO.groupsToInsert))
    conditionsTimer.echoStep('updateEmptyGroupVisibility')
    conditionsTimer.echo()
    return {
      questions: conditionsQuestions,
      screens: conditionsScreens,
      groups: conditionsGroups
    }
  }

  updateConditions() {
    this.conditionsDTO.focused = this.readingConditionStore.conditionsExistForReading();
    return this.createConditions()
  }
}